import { combineReducers } from 'redux'
import CoinListReducers from './index'

export default combineReducers({
    CoinListReducers,
  // Here you can registering another reducers.
})